import FuseAnimate from '@fuse/core/FuseAnimate';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import { ThemeProvider, withStyles } from '@mui/styles';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import moment from 'moment';
import React from 'react';
import Toolbar from 'react-big-calendar/lib/Toolbar';
import { navigate } from 'react-big-calendar/lib/utils/constants';
import { connect } from 'react-redux';

/* eslint-disable react/jsx-no-bind */
const styles = theme => ({
	root: {
		color: '#FFFFFF',
		backgroundColor: '#212529',
	}
});

const viewNamesObj = {
	month: {
		title: 'Month',
		icon: 'view_module'
	},
	week: {
		title: 'Week',
		icon: 'view_week'
	},
	day: {
		title: 'Day',
		icon: 'view_day'
	},
	year: {
		title: 'Year',
		icon: 'view_agenda'
	}
};

class CalendarHeader extends Toolbar {
	viewButtons() {
		const viewNames = this.props.views;
		const { view } = this.props;

		if (viewNames?.length > 1) {
			return viewNames?.map(name => (
				<Tooltip title={viewNamesObj[name]?.title} key={name}>
					<div>
						<FuseAnimate animation="transition.expandIn" delay={500}>
							<IconButton
								aria-label={name}
								onClick={() => this.props.onView(name)}
								disabled={view === name}
							>
								<Icon>{viewNamesObj[name]?.icon}</Icon>
							</IconButton>
						</FuseAnimate>
					</div>
				</Tooltip>
			));
		}
		return null;
	}

	render() {
		const { classes, theme, label, date } = this.props;
		return (
			<ThemeProvider theme={theme}>
				<div className={clsx(classes.root, 'flex relative', moment(date).format('MMM'))}>
					<div className="flex flex-1 flex-col p-24 justify-between z-10 container">
						<div className="text-24 md:text-32 font-extrabold tracking-tight">
							{/* <h1>{"Holidays & Events"}</h1> */}
						</div>
						<div className="flex flex-col items-center justify-between sm:flex-row">
							<div className="flex items-center my-16 sm:mb-0">
								<Typography variant="h6">{label}</Typography>
								<Tooltip title="Previous">
									<IconButton
										aria-label="Previous"
										onClick={this.navigate.bind(null, navigate.PREVIOUS)}
									>
										<Icon>
											{theme.direction === 'ltr' ? 'chevron_left' : 'chevron_right'}
										</Icon>
									</IconButton>
								</Tooltip>
								
								<Tooltip title="Next">
									<IconButton aria-label="Next" onClick={this.navigate.bind(null, navigate.NEXT)}>
										<Icon>
											{theme.direction === 'ltr' ? 'chevron_right' : 'chevron_left'}
										</Icon>
									</IconButton>
								</Tooltip>
							</div>
							<div className="flex items-center">
								<Tooltip title="Today">
									<div>
										<FuseAnimate animation="transition.expandIn" delay={500}>
											<IconButton
												aria-label="today"
												onClick={this.navigate.bind(null, navigate.TODAY)}
											>
												<Icon>today</Icon>
											</IconButton>
										</FuseAnimate>
									</div>
								</Tooltip>
								{this.viewButtons()}
							</div>
						</div>
						{/* <SearchHoliday /> */}
					</div>
				</div>
			</ThemeProvider>
		);
	}
}

function mapStateToProps({ fuse }) {
	return {
		mainThemeDark: fuse.settings.mainThemeDark
	};
}

export default connect(mapStateToProps)(withStyles(styles, { withTheme: true })(CalendarHeader));

